import styled from 'styled-components';
import { HistoryGraphLoading } from '../../styles';

export const UnitsInfoContainer = styled.div<{ loading?: boolean }>`
  display: grid;
  grid-template-columns: repeat(4, 169px);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 169px));
  }

  .react-loading-skeleton {
    height: 166px;
  }

  ${({ loading }) => (loading ? `
    @media (max-width: 768px) {
      width: 100%;
      grid-template-columns: repeat(2, 1fr);

      .skeleton-span, .skeleton-container-span {
        width: 100%;
      }
    }
  ` : '')}

  @media (min-width: 1024px) and (max-width: 1440px) {
    grid-template-columns: repeat(4, 140px);

    .react-loading-skeleton {
      height: 140px;
    }
  }
`;

export const HistoryCardLoading = styled(HistoryGraphLoading)`
  .skeleton-span {
    width: 712px;
  }

  @media (max-width: 768px) {
    width: 100%;

    .skeleton-container-span {
      width: 100%;
    }

    .skeleton-span {
      width: 100%;
    }
  }

  @media (min-width: 1024px) and (max-width: 1440px) {
    .skeleton-span {
      max-width: 596px;
    }
  }
`;
